import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { CMS } from '~/scopes/cms/routes-names'

import translations from './useExtendedServicesCards.translations'

export function useExtendedServicesCards() {
  const i18n = useI18n()
  const locale = useI18nLocale()
  const { market } = useMarketplace()

  const cards = computed(() =>
    [
      {
        image: '/img/navigation/protection-services.webp',
        title: i18n(translations.protectionServicesTitle),
        description: i18n(translations.protectionServicesDescription),
        ctaLabel: i18n(translations.protectionServicesCta),
        ctaUrl: `/${locale}/service/ext-services`,
        trackingValue: 'back_up',
      },
      {
        image: '/img/navigation/repair-services.webp',
        title: i18n(translations.repairServicesTitle),
        description: i18n(translations.repairServicesDescription),
        ctaLabel: i18n(translations.repairServicesCta),
        ctaUrl: `/${locale}/${CMS.REPAIR_AND_CARE}`,
        trackingValue: 'repair',
      },
      market.countryCode === MarketCountryCode.US
        ? undefined
        : {
            image: '/img/navigation/express-replacement.webp',
            title: i18n(translations.expressReplacementTitle),
            description: i18n(translations.expressReplacementDescription),
            ctaLabel: i18n(translations.expressReplacementCta),
            ctaUrl: `/${locale}/${CMS.EXPRESS_REPLACEMENT}`,
            trackingValue: 'express_replacement',
          },
    ].filter((card) => card !== undefined),
  )

  return { cards }
}
